import { Navigate } from "react-router-dom";
import { getUser, getToken } from "../api/auth";

export const PERMISSION_ROUTES = {
    Dashboard: {
        organization: "/organization",
        user: "/user",
    },

    Brands: {
        organization: "/organization/brands",
    },

    Templates: {
        organization: "/organization/templates",
        user: "/user/templates",
    },

    Creatives: {
        organization: "/organization/creatives",
        user: "/user/creatives",
    },

    Campaigns: {
        organization: "/organization/campaigns",
        user: "/user/campaigns",
    },

    Users: {
        organization: "/organization/users",
    },

    "XML Tester": {
        organization: "/organization/xml-tester",
        user: "/user/xml-tester",
    },

    "Dynamic QR": {
        organization: "/organization/qr-generator",
        user: "/user/qr-generator",
    },

    Plans: {
        organization: "/organization/plans",
    },

    Subscription: {
        organization: "/organization/subscription",
    },
};

export const getDefaultRoute = (user) => {
    console.log(user, '>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')
    if (user.role === "admin") {
        return "/admin";
    }

    const firstPermission = user.permissions?.find((p) => p.per_view);
    console.log(firstPermission, "firstPermission")

    if (!firstPermission) {
        return "/";
    }

    return (
        PERMISSION_ROUTES[firstPermission.per_name]?.[user.role] ||
        `/${user.role}`
    );
};

export default function ProtectedRoute({
    children,
    roles = [],
    redirectTo = "/",
    publicOnly = false,
}) {
    const user = getUser();
    const token = getToken();

    const isAuthenticated = !!user && !!token;

    if (publicOnly) {
        if (isAuthenticated) {
            return (
                <Navigate
                    to={getDefaultRoute(user)}
                    replace
                />
            );
        }

        return children;
    }

    // Protected pages
    if (!isAuthenticated) {
        return <Navigate to={redirectTo} replace />;
    }

    // Role check
    if (roles.length && !roles.includes(user.role)) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
}